import type { NodeJson } from "@corca/data";

/**
 * Replace reference and calculated-result nodes with their cached value
 * (children), wrapped in a parenthesized group to preserve precedence.
 */
export function substituteReferenceNodes(node: NodeJson): NodeJson {
  if (node.type === "computedReference" || node.type === "computedResult") {
    return {
      type: "group",
      props: { openingSymbol: "(", closingSymbol: ")" },
      children: [
        {
          type: "inline",
          props: {},
          children: node.children.map(substituteReferenceNodes),
        },
      ],
    };
  }

  return { ...node, children: node.children.map(substituteReferenceNodes) };
}
